<!--
 * @Author: DY
 * @Date: 2020-07-23 14:53:47
 * @LastEditTime: 2020-08-04 16:20:05
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \JiYun_Mobile_dev\src\views\salesTerminal\abnormalProduction\abnormal.vue
-->
<template>
    <div class="abnormal">
        <div class="top-wrapper">
            <div class="select-wrapper">
                <div class="select-item">
                    <div @click="startTimePicker = true">
                        <span>{{ startTimeValue }}</span>
                        <i class="iconfont iconxiala"></i>
                    </div>
                    <p>—</p>
                    <div @click="endTimePicker = true">
                        <span>{{ endTimeValue }}</span>
                        <i class="iconfont iconxiala"></i>
                    </div>
                </div>
                <div
                    class="select-item Station"
                    @click="showPicker = true"
                >
                    <span>{{ StationName }}</span>
                    <i class="iconfont iconxiala"></i>
                </div>
                <!-- 选择场站 -->
                <van-popup
                    v-model="showPicker"
                    position="bottom"
                >
                    <van-picker
                        show-toolbar
                        :columns="columns"
                        @cancel="showPicker = false"
                        @confirm="onConfirm"
                    ></van-picker>
                </van-popup>
                <!-- 开始时间 -->
                <van-popup
                    v-model="startTimePicker"
                    position="bottom"
                    :overlay="true"
                >
                    <van-datetime-picker
                        v-model="startCurrentDate"
                        type="date"
                        title="选择年月日"
                        @confirm="startConfirmData"
                        @cancel="startTimePicker = false"
                    ></van-datetime-picker>
                </van-popup>
                <!-- 结束时间 -->
                <van-popup
                    v-model="endTimePicker"
                    position="bottom"
                    :overlay="true"
                >
                    <van-datetime-picker
                        v-model="endCurrentDate"
                        type="date"
                        title="选择年月日"
                        @confirm="endConfirmData"
                        @cancel="endTimePicker = false"
                    ></van-datetime-picker>
                </van-popup>
            </div>
        </div>
        <div class="quantityStatistics">
            <div class="total">
                <h5>异常打料方量</h5>
                <div class="content">
                    <div class="box" :class="{'active': queryType == 0}" @click="abnormalSwitch('0')">
                        <div>
                            <h6>{{ volumeData.ycdlfl_hnt }}</h6>
                            <p>混凝土(方)</p>
                        </div>
                    </div>
                    <div class="box" :class="{'active': queryType == 1}" @click="abnormalSwitch('1')">
                        <div>
                            <h6>{{ volumeData.ycdlfl_sj }}</h6>
                            <p>砂浆(方)</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="detailedQuantity">
                <div>
                    <table>
                        <tbody>
                            <tr>
                                <td>
                                    <h5>异常新增任务(个)</h5>
                                    <p>{{ volumeData.ycrws }}</p>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <span>混凝土(方)：</span>
                                    <strong>{{ volumeData.ycrw_hnt }}</strong>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <span>砂浆(方)：</span>
                                    <strong>{{ volumeData.ycrw_sj }}</strong>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div>
                    <table>
                        <tbody>
                            <tr>
                                <td>
                                    <h5>异常新增派单(个)</h5>
                                    <p>{{ volumeData.ycpds }}</p>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <span>混凝土(方)：</span>
                                    <strong>{{ volumeData.ycpd_hnt }}</strong>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <span>砂浆(方)：</span>
                                    <strong>{{ volumeData.ycpd_sj }}</strong>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div>
                    <table>
                        <tbody>
                            <tr>
                                <td>
                                    <h5>异常加量</h5>
                                    <p>{{ volumeData.yczls }}</p>
                                </td>
                                <td>
                                    <h5>减量(个)</h5>
                                    <p>{{ volumeData.ycjls }}</p>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <h5>混凝土(方)</h5>
                                    <p>+{{ volumeData.yczl_hnt }}</p>
                                </td>
                                <td>
                                    <h5>混凝土</h5>
                                    <p>-{{ volumeData.ycjl_hnt }}</p>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <h5>砂浆(方)</h5>
                                    <p>+{{ volumeData.yczl_sj }}</p>
                                </td>
                                <td>
                                    <h5>砂浆</h5>
                                    <p>-{{ volumeData.ycjl_sj }}</p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="charts">
            <div class="charts_header">
                <van-tabs
                    type="card"
                    color="#3495FB"
                    v-model="tabActive"
                    @click="tabSelect"
                >
                    <template v-for="(item,index) in tabData">
                        <van-tab :key="index" :title="item.name" :disabled="item.disabled"></van-tab>
                    </template>
                </van-tabs>
            </div>
            <div class="chart">
                <div id="chart1"></div>
            </div>
        </div>
        <div class="charts">
            <div class="chart">
                <div id="chart2"></div>
            </div>
        </div>
    </div>
</template>
<script>
import {
    progressBarChart,
    areaChart,
} from '@/assets/js/charts';

export default {
    // 异常打料
    name: 'abnormal',
    components: {},
    props: {},
    data() {
        return {
            // 开始时间text
            startTimeValue: '',
            // 结束时间text
            endTimeValue: '',
            // 开始时间弹出层
            startTimePicker: false,
            // 结束时间弹出层
            endTimePicker: false,
            // 开始时间默认日期
            startCurrentDate: new Date(new Date().getTime() - 3600 * 1000 * 24 * 6),
            // 结束时间默认日期
            endCurrentDate: new Date(),
            // 场站名称
            StationName: '',
            // 场站id
            StationId: '',
            // 场站待选数据集合
            columns: [],
            // 默认待选场站
            StationData: [
                {
                    station_id: '',
                    station_name: '全部',
                },
            ],
            // 场站弹出层状态
            showPicker: false,
            // tab选项
            tabData: [{
                name: '按场站',
                disabled: false,
            }, {
                name: '按机组',
                disabled: false,
            }, {
                name: '按人员',
                disabled: false,
            }],
            // tab默认值
            tabActive: 0,
            // 头部异常方量数据
            volumeData: {
                // 异常打料方量_混凝土（方）
                ycdlfl_hnt: 0,
                // 异常打料方量_砂浆（方）
                ycdlfl_sj: 0,
                // 异常任务_数量
                ycrws: 0,
                // 异常任务_混凝土（方）
                ycrw_hnt: 0,
                // 异常任务_砂浆（方）
                ycrw_sj: 0,
                // 异常派单_数量
                ycpds: 0,
                // 异常派单_混凝土（方）
                ycpd_hnt: 0,
                // 异常派单_砂浆（方）
                ycpd_sj: 0,
                // 异常加量_数量
                yczls: 0,
                // 异常加量_混凝土（方）
                yczl_hnt: 0,
                // 异常加量_砂浆（方）
                yczl_sj: 0,
                // 异常减量_数量
                ycjls: 0,
                // 异常减量_混凝土（方）
                ycjl_hnt: 0,
                // 异常减量_砂浆（方）
                ycjl_sj: 0,
            },
            // 查询类型 0混凝土 1砂浆
            queryType: 0,
        };
    },
    created() {
        this.startTimeValue = this.formatDate(this.startCurrentDate);
        this.endTimeValue = this.formatDate(this.endCurrentDate);
    },
    computed: {},
    watch: {
        startTimeValue(newVal) {
            if (newVal !== '') {
                if (this.StationData.length < 2) {
                    // 获取场站
                    this.getStationList();
                } else {
                    this.init();
                }
            }
        },
        endTimeValue() {
            this.init();
        },
        StationId(newVal) {
            if (newVal !== '') {
                this.tabData[0].disabled = true;
                if (this.tabActive === 0) {
                    this.tabActive = 1;
                }
            } else {
                this.tabData[0].disabled = false;
            }
            this.init();
        },
        queryType() {
            this.init();
        },
    },
    mounted() {},
    destroyed() { },
    methods: {
        // 获取企业下所有场站
        getStationList() {
            let stationIds = this.$takeTokenParameters('StationIds');
            if (stationIds) {
                stationIds = stationIds.split(',');
                const stationNames = this.$takeTokenParameters('StationNames').split(',');
                const stationList = stationIds.map((id, index) => {
                    return {
                        station_id: id,
                        station_name: stationNames[index],
                    };
                });
                this.StationData.push(...stationList);
                this.columns = this.StationData.map(item => item.station_name);
                this.StationName = this.columns[0];
                this.StationId = this.StationData[0].station_id;
                this.init();
            }
        },
        // 初始化页面
        init() {
            // 获取头部异常打料方量数据
            this.getVolumeData();
            this.tabSelect();
            // 获取异常打料——按时间
            this.getAbnormal_time();
        },
        // 类型切换 0混凝土 1砂浆
        abnormalSwitch(type) {
            this.queryType = type;
        },
        // tab切换
        tabSelect() {
            if (this.tabActive === 0) {
                this.getAbnormal_station();
            } else if (this.tabActive === 1) {
                this.getAbnormal_crew();
            } else if (this.tabActive === 2) {
                this.getAbnormal_personnel();
            }
        },
        // 获取头部异常打料方量数据
        getVolumeData() {
            this.$axios
                .get(`/interfaceApi/report/ycdl/tjs?station_id=${this.StationId}&start_time=${this.startTimeValue}&end_time=${this.endTimeValue}`)
                .then(res => {
                    this.volumeData = res;
                })
                .catch(error => {
                    this.$toast.fail(error.ErrorCode.Message);
                });
        },
        // 获取异常打料——场站
        getAbnormal_station() {
            this.$axios
            // eslint-disable-next-line max-len
                .get(`/interfaceApi/report/ycdl/tjlb/cz?type=${this.queryType}&start_time=${this.startTimeValue}&end_time=${this.endTimeValue}`)
                .then(res => {
                    const chartData = {
                        xdata: [],
                        legendData: ['混凝土', '砂浆'],
                        ydata: [
                            {
                                name: '混凝土',
                                color: ['#EFAB54', '#FA8B47'],
                                data: [],
                            }, {
                                name: '砂浆',
                                color: ['#55A7FE', '#3E79C5'],
                                data: [],
                            },
                        ],
                    };
                    res.forEach(item => {
                        chartData.xdata.push(item.name);
                        chartData.ydata[0].data.push(item.hnt);
                        chartData.ydata[1].data.push(item.sj);
                    });
                    progressBarChart('chart1', chartData);
                })
                .catch(error => {
                    this.$toast.fail(error.ErrorCode.Message);
                });
        },
        // 获取异常打料——机组
        getAbnormal_crew() {
            this.$axios
            // eslint-disable-next-line max-len
                .get(`/interfaceApi/report/ycdl/tjlb/jz?type=${this.queryType}&station_id=${this.StationId}&start_time=${this.startTimeValue}&end_time=${this.endTimeValue}`)
                .then(res => {
                    const chartData = {
                        xdata: [],
                        legendData: ['混凝土', '砂浆'],
                        ydata: [
                            {
                                name: '混凝土',
                                color: ['#EFAB54', '#FA8B47'],
                                data: [],
                            }, {
                                name: '砂浆',
                                color: ['#55A7FE', '#3E79C5'],
                                data: [],
                            },
                        ],
                    };
                    res.forEach(item => {
                        chartData.xdata.push(item.name);
                        chartData.ydata[0].data.push(item.hnt);
                        chartData.ydata[1].data.push(item.sj);
                    });
                    progressBarChart('chart1', chartData);
                })
                .catch(error => {
                    this.$toast.fail(error.ErrorCode.Message);
                });
        },
        // 获取异常打料——人员
        getAbnormal_personnel() {
            this.$axios
            // eslint-disable-next-line max-len
                .get(`/interfaceApi/report/ycdl/tjlb/ry?type=${this.queryType}&station_id=${this.StationId}&start_time=${this.startTimeValue}&end_time=${this.endTimeValue}`)
                .then(res => {
                    const chartData = {
                        xdata: [],
                        legendData: ['混凝土', '砂浆'],
                        ydata: [
                            {
                                name: '混凝土',
                                color: ['#EFAB54', '#FA8B47'],
                                data: [],
                            }, {
                                name: '砂浆',
                                color: ['#55A7FE', '#3E79C5'],
                                data: [],
                            },
                        ],
                    };
                    res.forEach(item => {
                        chartData.xdata.push(item.name);
                        chartData.ydata[0].data.push(item.hnt);
                        chartData.ydata[1].data.push(item.sj);
                    });
                    progressBarChart('chart1', chartData);
                })
                .catch(error => {
                    this.$toast.fail(error.ErrorCode.Message);
                });
        },
        // 获取异常打料——按时间
        getAbnormal_time() {
            this.$axios
            // eslint-disable-next-line max-len
                .get(`/interfaceApi/report/ycdl/tjlbtj/rq?type=${this.queryType}&station_id=${this.StationId}&start_time=${this.startTimeValue}&end_time=${this.endTimeValue}`)
                .then(res => {
                    const chartData = {
                        xdata: [],
                        legendData: ['混凝土', '砂浆'],
                        ydata: [
                            {
                                name: '混凝土',
                                color: ['rgba(85, 136, 241, 1)', 'rgba(85, 136, 241, 0.3)', 'rgba(85, 136, 241, 0)'],
                                data: [],
                            }, {
                                name: '砂浆',
                                color: ['rgba(33, 189, 204, 1)', 'rgba(33, 189, 204, 0.3)', 'rgba(33, 189, 204, 0)'],
                                data: [],
                            },
                        ],
                    };
                    res.forEach(item => {
                        chartData.xdata.push(item.name);
                        chartData.ydata[0].data.push(item.hnt);
                        chartData.ydata[1].data.push(item.sj);
                    });
                    areaChart('chart2', chartData);
                })
                .catch(error => {
                    this.$toast.fail(error.ErrorCode.Message);
                });
        },
        // 确认选择场站
        onConfirm(val, index) {
            this.showPicker = false;
            this.StationName = this.StationData[index].station_name;
            this.StationId = this.StationData[index].station_id;
        },
        // 确认选择开始时间
        startConfirmData(val) {
            this.startTimeValue = this.formatDate(val);
            this.startTimePicker = false;
        },
        // 确认选择结束时间
        endConfirmData(val) {
            this.endCurrentDate = val;// 结束时间默认日期
            this.endTimePicker = false;
            this.endTimeValue = this.formatDate(val);
        },
        // 时间格式处理
        formatDate(date) {
            date = new Date(date);
            const y = date.getFullYear();
            let m = date.getMonth() + 1;
            let d = date.getDate();
            m = m < 10 ? '0' + m : m;
            d = d < 10 ? '0' + d : d;
            return y + '-' + m + '-' + d;
        },
    },
};
</script>
<style lang="stylus" scoped>
.abnormal
    height 100%
    .top-wrapper
        background #ffffff
        padding 10rpx
        .select-wrapper
            height 45rpx
            box-shadow 0px 2px 8px 0px rgba(0, 0, 0, 0.16)
            border-radius 8px
            display flex
            .select-item
                flex 1
                text-align center
                span
                    font-size 14rpx
                    font-weight 400
                    line-height 45rpx
                i
                    color #979EA7
                &:first-child
                    flex 2
                    display flex
                    div
                        flex 1
                    p
                        line-height 45rpx
                        color #979EA7
                        font-weight 400
            .Station
                span
                    color #3495FB
                    padding-left 20rpx
                    border-left 2rpx solid #D7D7D7
    .quantityStatistics
        .total
            margin 15rpx
            height 108rpx
            background linear-gradient(133deg, rgba(242, 73, 64, 1) 0%, rgba(248, 96, 87, 1) 100%)
            box-shadow 1px 1px 4px 0px rgba(0, 0, 0, 0.2)
            border-radius 4rpx
            h5
                border-bottom 1px solid rgba(255, 255, 255, 0.2)
                font-size 12rpx
                line-height 30rpx
                color #ffffff
                text-align center
            .content
                height 78rpx
                overflow hidden
                position relative
                &:after
                    content ''
                    height 30rpx
                    position absolute
                    top 24rpx
                    left 50%
                    border-left 1px solid rgba(255, 255, 255, 0.2)
                .box
                    width 50%
                    height 100%
                    float left
                    position relative
                    div
                        position absolute
                        top 50%
                        left 50%
                        transform translate(-50%, -50%)
                        width 120rpx
                        height 50rpx
                        background #FD715F
                        border-radius 4rpx
                        color #fff
                        text-align center
                        h6
                            font-size 16rpx
                            font-size 24rpx
                        p
                            font-size 10rpx
                            line-height 15rpx
                    &.active
                        div
                            color #EA3747
                            background #FFFFFF
        .detailedQuantity
            padding 0 10rpx 15rpx 10rpx
            overflow hidden
            div
                float left
                width calc((100% / 3) - 10rpx)
                margin 0 5rpx
                background rgba(245, 248, 254, 1)
                box-shadow 1px 1px 2px 0px rgba(0, 0, 0, 0.2)
                border-radius 4px
                text-align center
                table
                    width 100%
                    height 100%
                    border-collapse collapse
                    tr
                        &:nth-of-type(1)
                            background #EBF0FC
                        &:nth-of-type(2)
                            border-bottom 1px dashed #E5EBF9
                            strong,p
                                color #5588F1
                        &:nth-of-type(3)
                            strong,p
                                color #FA8436
                        td
                            height 40rpx
                h5
                    font-size 10rpx
                    color #666
                    white-space nowrap
                p
                    font-size 14rpx
                    color #21BDCC
                span
                    font-size 10rpx
                    color #666666
                    vertical-align middle
                strong
                    font-size 14rpx
                    font-weight 400
                    vertical-align middle
    .charts
        overflow hidden
        padding 10rpx
        border-top 15rpx solid #F0F0F0
        .charts_header
            margin 12rpx 35rpx
            .van-tabs__nav
                margin 0
        .chart
            height 221rpx
            >div
                height 100%
</style>
